import React, { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const DEBUG = process.env.REACT_APP_ADSENSE_DEBUG === "true";

// One AdSense unit per format, as created in the AdSense dashboard.
const UNITS = {
  display: {
    slot: process.env.REACT_APP_ADSENSE_SLOT_DISPLAY,
    style: { display: "block" },
    attrs: { "data-ad-format": "auto", "data-full-width-responsive": "true" },
  },
  "in-article": {
    slot: process.env.REACT_APP_ADSENSE_SLOT_INARTICLE,
    style: { display: "block", textAlign: "center" },
    attrs: { "data-ad-layout": "in-article", "data-ad-format": "fluid" },
  },
  "in-feed": {
    slot: process.env.REACT_APP_ADSENSE_SLOT_INFEED,
    style: { display: "block" },
    attrs: {
      "data-ad-format": "fluid",
      "data-ad-layout-key": process.env.REACT_APP_ADSENSE_INFEED_LAYOUT,
    },
  },
};

export const AdUnit = ({ variant = "display", label = "Advertisement" }) => {
  const unit = UNITS[variant];
  const pushed = useRef(false);

  useEffect(() => {
    if (!CLIENT || !unit?.slot || pushed.current) return;
    pushed.current = true; // Strict Mode mounts twice; a second push duplicates the ad
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* library loads async; AdSense drains the queue itself */
    }
  }, [unit]);

  if (!CLIENT || !unit?.slot) return null;

  return (
    <aside
      className={`ad-slot ad-slot-${variant}${DEBUG ? " is-debug" : ""}`}
      aria-label={label}
      data-testid={`ad-unit-${variant}`}
    >
      <span className="ad-slot-label">
        {DEBUG ? `${label} · ${variant} · slot ${unit.slot}` : label}
      </span>
      <ins
        className="adsbygoogle"
        style={unit.style}
        data-ad-client={CLIENT}
        data-ad-slot={unit.slot}
        {...unit.attrs}
      />
    </aside>
  );
};

export default AdUnit;
